export function getUserId(): number | null {
  const state = localStorage.getItem("simolapps_state");
  try {
    const parsed = JSON.parse(state ?? "{}");
    return parsed?.user?.id ?? null;
  } catch {
    return null;
  }
}
